import { useEffect } from "react";
import { useUiStore } from "../state/uiStore";

/** Applique prefs.theme sur <html data-theme> — « auto » suit
 * prefers-color-scheme et se met à jour en direct. */
export function useTheme() {
  const theme = useUiStore((s) => s.prefs.theme);

  useEffect(() => {
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const apply = () => {
      const resolved =
        theme === "auto" ? (mq.matches ? "dark" : "light") : theme;
      document.documentElement.dataset.theme = resolved;
    };
    apply();
    if (theme === "auto") {
      mq.addEventListener("change", apply);
      return () => mq.removeEventListener("change", apply);
    }
  }, [theme]);
}
